
import { DogSchool } from "@/data/dogSchools";
import { dogSchools } from "@/data/dogSchools";
import { fetchPaginatedDogSchools as fetchPaginatedSchools } from "./paginated/paginatedService";
import { fetchDogSchoolsByState as fetchStateSchools } from "./state/stateService";
import { fetchDogSchoolsByCountry as fetchCountrySchools } from "./country/countryService";
import { fetchDogSchoolsByPostalCode as fetchPostalSchools } from "./postal/postalService";
import { FilterParams } from "./utils/filterUtils";

/**
 * Export functions from specialized services
 */
export const fetchDogSchoolsByState = fetchStateSchools;
export const fetchDogSchoolsByCountry = fetchCountrySchools;
export const fetchDogSchoolsByPostalCode = fetchPostalSchools;

/**
 * Fetch dog schools with pagination
 * This is a wrapper around the paginated service
 */
export const fetchPaginatedDogSchools = async (
  page: number = 0,
  pageSize: number = 50, // Default to initial 50
  filters: FilterParams = {}
): Promise<{
  schools: DogSchool[];
  hasMore: boolean;
  totalCount?: number;
}> => {
  console.log(`Fetching paginated dog schools, page: ${page}, size: ${pageSize}, filters:`, filters);
  
  try {
    return await fetchPaginatedSchools(page, pageSize, filters);
  } catch (error) {
    console.error("Error in fetchPaginatedDogSchools wrapper:", error);
    throw error;
  }
};
